"use client";

import { Box, Button, Typography } from "@mui/material";
import Link from "next/link";
import { useTranslations } from "next-intl";

export default function NotFoundPage() {
  const t = useTranslations("NotFound");
  return (
    <Box sx={{ textAlign: "center", mt: 8 }}>
      <Typography variant="h2" gutterBottom>
        {t("title")}
      </Typography>
      <Typography variant="body1">{t("body")}</Typography>
      <Link href="/" style={{ textDecoration: "none" }}>
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          {t("backToCalculators")}
        </Button>
      </Link>
    </Box>
  );
}
